import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cb17477"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col w-full sm:w-1/5 text-center p-3 sm:p-1 justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base" }, "Estimated Rewards", -1))
const _hoisted_3 = { class: "text-4xl bsl-green-gradient" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FixedScheduleDisplay = _resolveComponent("FixedScheduleDisplay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getEstimatedRewards(_ctx.reward, _ctx.gems, _ctx.currentTS)) + " $FORGE ", 1)
    ]),
    (_openBlock(), _createBlock(_component_FixedScheduleDisplay, {
      key: _ctx.farmReward,
      gems: _ctx.gems,
      schedule: _ctx.reward?.fixedRate.promisedSchedule,
      multipler: _ctx.promisedReward(_ctx.reward, _ctx.currentTS)
    }, null, 8, ["gems", "schedule", "multipler"]))
  ], 64))
}